import { render, staticRenderFns } from "./ingresarSolicitudCompra.vue?vue&type=template&id=7944b8f1&scoped=true&"
import script from "./ingresarSolicitudCompra.vue?vue&type=script&lang=js&"
export * from "./ingresarSolicitudCompra.vue?vue&type=script&lang=js&"
import style0 from "./ingresarSolicitudCompra.vue?vue&type=style&index=0&id=7944b8f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7944b8f1",
  null
  
)

export default component.exports